export const LANGS = ['ja', 'en'] as const;

export type Lang = (typeof LANGS)[number];

export const DEFAULT_LANG: Lang = 'ja';

const EN_PREFIX = '/en';

export const isLang = (value: string): value is Lang => (LANGS as readonly string[]).includes(value);

/** `/en` と `/en/...` だけを英語と見なす。`/energy` のような前方一致の巻き込みを避ける */
export const detectLangFromPath = (pathname: string): Lang =>
  pathname === EN_PREFIX || pathname.startsWith(`${EN_PREFIX}/`) ? 'en' : DEFAULT_LANG;

/** 言語プレフィックスを外し、日本語側の正規パスに戻す */
export const stripLangPrefix = (pathname: string): string => {
  if (pathname === EN_PREFIX) return '/';
  if (pathname.startsWith(`${EN_PREFIX}/`)) return pathname.slice(EN_PREFIX.length);
  return pathname;
};

/** 日本語側の正規パスを、指定言語で実際に配信されるパスへ変換する */
export const localizePath = (path: string, lang: Lang): string => {
  const canonical = stripLangPrefix(path);
  if (lang === DEFAULT_LANG) return canonical;
  return canonical === '/' ? EN_PREFIX : `${EN_PREFIX}${canonical}`;
};
